<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      @open='open'
      @cancel='cancel'
      @print='print'
      @deleteItem='deleteItem'
      :current='page'
      :disablePage='disablePage'
      :count='count'
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>供应商名称:</label>
            <SupplierListSelect multiple v-model="query.supplierStoreIdList"></SupplierListSelect>
          </div>
          <div class="queryItem">
            <label>社会统一码:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.creditCode'></lk-input>
          </div>
          <div class="queryItem">
            <label>助记码:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.mnemonicCode' />
          </div>
          <div class="queryItem">
            <label>编码:</label>
            <lk-input :maxlength='100' class="item" placeholder='请输入' clearable v-model.trim='query.code' />
          </div>
          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker type='daterange' class="item" placeholder=" 请选择" clearable v-model.trim='query.duration' :options='creatTimeOption'/>
          </div>
          <div class="queryItem">
            <label>审批通过时间:</label>
            <timeStampDatePicker type='daterange' class="item" placeholder=" 请选择" clearable v-model.trim='query.auditTime' :options='approvalTimeOption'/>
          </div>
          <div class="queryItem">
            <label>审批状态:</label>
            <lk-select clearable class="item" v-model.trim='query.auditStatus'>
              <lk-option v-for="(item,index) in aduitList" :key="item" :value='index+1'>{{item}}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>状态:</label>
            <lk-select clearable class="item" v-model.trim='query.status'>
              <lk-option v-for="(item,index) in statusList" :key="item" :value='index+1'>{{item}}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-button
            class="mr8"
            type="primary"
            icon="md-add"
            @click="addNew"
            v-if="handlePermission('supplierStoreAdd')">新建首营供应商
          </lk-button>
          <DownloadButton class="mb16" @on-click="download" v-if="handlePermission('supplierStoreDownload')"></DownloadButton>
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>
      <!-- <lk-modal v-model="statusModal" title="禁用原因"  :mask-closable='false' :closable='false'>
          <div>
            <lk-input type='textarea' :row='4' placeholder="请输入禁用原因" v-model="disableReason">

            </lk-input>
          </div>

            <div slot="footer">
              <lk-button @click="statusModal = false;  getData(); disableReason=''">取消</lk-button>
              <lk-button type='primary' :loading='disableLoading' @click="handleDisable">确定</lk-button>
            </div>
        </lk-modal> -->
        <lk-modal
        :title="isStop ? '停用供应商' : '启用供应商'"
        v-model="statusModal"
        :footer-hide='true'
        width="400"
        :closable='false'
        :mask-closable='false'>
      <div style="display:flex;">
          <span class="warnIcon iconfont">&#xe613;</span> &nbsp;
          <h6 style="margin-top: 7px;font-size: 12px;">是否确认{{ isStop ? '停用' : '启用'}}此供应商？</h6>
      </div>
      <div style="display:flex">
        <span v-if="isStop" class="redMark">*</span>
        <span :class="isStop ? 'stopReason' : 'reason'">{{ isStop ? '停用原因：' : '停用原因：' + disableReason}}</span>
      </div>
      <lk-input v-if="isStop" class="stopInput" placeholder='请输入停用原因' :maxlength="100" clearable v-model.trim="disableReason" type="textarea"></lk-input>
      <div class="bottomButton">
          <lk-button type='primary' :disabled="isStop ? disableReason == '' : false" @click="editGoods(disableId)">确认</lk-button>
          <lk-button @click="statusModal=false, getData()">取消</lk-button>
      </div>
    </lk-modal>
  </div>
</template>

<script>
import QueryFrame from '../../../components/frame/QueryFrame.vue';
// import timeStampDatePicker from '../../../components/timeStampDatePicker.vue';
import supplier from '../../../services/supplier';
import utils from '../../../libs/utils';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';
import DownloadButton from '../../../components/download/DownloadButton';
import SupplierListSelect from '../../../components/SupplierListSelect.vue';

export default {
  name: 'SupplierStore',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DownloadButton,
    SupplierListSelect,
  },
  data() {
    return {
      isStop: true,
      statusModal: false,
      disableLoading: false,
      disableReason: '',
      disableId: null,
      disablePage: false,
      enterpriseTypeList: ['', '药品经营', '药品生产', '食品（生产、经营）', '器械生产', '器械经营', '化妆品'],

      aduitList: ['草稿', '审批中', '审批通过', '审批驳回'],
      statusList: ['启用', '禁用'],
      approvalTimeOption: this.approvalDate(),
      creatTimeOption: this.creatDate(),
      params: {
        duration: [],
        supplierStoreIdList: [],
        mnemonicCode: '',
        creditCode: '',
        code: '',
        createTimeMs: '',
        status: '',
        statusCodeList: [],
        auditStatus: null,
      },
      query: {
        duration: [],
        // supplierStoreIdList: [],
        name: '',
        mnemonicCode: '',
        creditCode: '',
        code: '',
        createTimeMs: '',
        status: '',
        statusCodeList: [],
        auditStatus: null,
        auditTime: [],
      },
      flowStatusList: ['', '草稿', '审批中', '审批通过', '审批驳回'],
      columns: [
        { title: '编码', key: 'code', minWidth: 116 },
        { title: '审批状态', key: 'flowStatus', minWidth: 116 },
        { title: '供应商名称', key: 'name', minWidth: 116 },
        { title: '社会统一码', key: 'socialUnifyCreditCode', minWidth: 116 },
        { title: '助记码', key: 'memoryCode', minWidth: 116 },
        { title: '企业法人', key: 'corporationPerson', minWidth: 116 },
        { title: '注册地址', key: 'detailAddress', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        { title: '审批通过时间', key: 'auditPassTime', minWidth: 116 },
        { title: '企业性质', key: 'enterpriseType', minWidth: 116 },
        {
          title: '状态',
          key: 'status',
          fixed: 'right',
          minWidth: 116,
          render: (h, params) => ((params.row.flowStatus !== '审批通过' || !this.handlePermission('supplierStoreEnableDisable')) ? h('span', params.row.status === 1 ? '启用' : '禁用')
            : h('lk-switch', {
              props: {
                size: 'large',
                value: params.row.status === 1,
                loading: params.row.loading,
              },
              on: {
                'on-change': (e) => { // 接口有问题后续调
                  params.row.loading = true;
                  if (e) {
                    this.isStop = false;
                    this.disableReason = params.row.disableReason || '';
                  } else {
                    this.isStop = true;
                    this.disableReason = '';
                  }
                  this.disableId = params.row.id;
                  this.statusModal = true;
                },
              },
            }, [
              h('span', {
                props: {
                },
                slot: 'open',

              }, '启用'),
              h('span', {
                props: {
                },
                slot: 'close',

              }, '禁用'),
            ])),

        },
        {
          title: '操作',
          width: 130,
          fixed: 'right',
          key: 'action',
          render: (h, params) => h('div', [
            this.handlePermission('supplierStoreCheck') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'supplierStoreCheck', params: { id: params.row.id } });
                },
              },
            }, '查看') : null,
            this.handlePermission('supplierStoreEdit') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: params.row.flowStatus === '审批中',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'supplierStoreEdit', params: { id: params.row.id } });
                },
              },
            }, '编辑') : null,
            params.row.flowStatus === '草稿' ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$Modal.confirm({
                    title: '是否确定删除',
                    cancelText: '取消',
                    onOk: () => {
                      this.onDelete(params.row.id);
                    },
                  });
                },
              },
            }, '删除') : null,
          ]),
        },
      ],
      tableData: [],
      localtion: [],
      status: ['启用', '禁用'],
    };
  },
  methods: {
    editGoods(id) {
      this.statusModal = false;
      if (!this.isStop) {
        supplier.supplierStoreEnable({ id }).then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('该供应商已启用');
          } else {
            this.$Message.error(res.data.error);
          }
          this.getData();
          this.disableReason = '';
        }).catch((err) => {
          this.getData();
          utils.handleError(err);
        });
      } else {
        this.handleDisable();
      }
    },
    download() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.duration[1]) {
        this.params.createTimeStartMs = this.params.duration[0];// (new Date()).getTime();
        this.params.createTimeEndMs = this.params.duration[1];// (new Date(this.params.duration[1])).getTime();
      } else {
        this.params.createTimeStartMs = '';
        this.params.createTimeEndMs = '';
      }
      if (this.params.auditTime) {
        this.params.auditStartTime = this.params.auditTime[0];// (new Date()).getTime();
        this.params.auditEndTime = this.params.auditTime[1];// (new Date(this.params.duration[1])).getTime();
      } else {
        this.params.auditStartTime = '';
        this.params.auditEndTime = '';
      }
      this.params.statusCodeList = this.params.status ? [this.params.status] : [];
      this.params.queryCondition = utils.getQueryCondition('.queryContainer');
      supplier.downloadStore(this.params).then((res) => {
        // utils.downLoadExcel(res, '销售明细查询');
        if (res.status !== 200) {
          this.$Message.error(res.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleDisable() {
      if (!this.disableReason) {
        this.$Message.error('请填写禁用原因');

        return;
      }
      this.disableLoading = true;
      supplier.supplierStoreDisable({ id: this.disableId, disableReason: this.disableReason }).then((res) => {
        this.disableReason = '';
        if (res.data.status === 200) {
          this.$Message.success('该供应商已禁用');
          this.statusModal = false;
        } else {
          this.$Message.error(res.data.error);
        }
        this.disableLoading = false;
        this.getData();
        // console.log(params.row.status);
      }).catch((err) => {
        this.getData();
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {
        duration: [],
        name: '',
        mnemonicCode: '',
        creditCode: '',
        code: '',
        // createTimeMs: '',
        status: '',
        statusCodeList: [],
        auditStatus: null,
      };
    },
    getlocaltions() {

    },
    loadLocaltion() {

    },
    // handleSearch() {
    //   this.params = Object.assign(this.params, this.query);
    //   this.handlePage(1, true);
    // },
    approvalDate() { // 处理时间禁用问题
      const vm = this;
      return {
        disabledDate(time) {
          if (vm.query.duration.length) {
            return time.getTime() < vm.query.duration[0] - 1000 * 60 * 60 * 24;
          }
        },
      };
    },
    creatDate() { // 处理时间禁用问题
      const vm = this;
      return {
        disabledDate(time) {
          if (vm.query.auditTime.length) {
            return time.getTime() > vm.query.auditTime[1];
          }
        },
      };
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.duration[1]) {
        this.params.createTimeStartMs = this.params.duration[0];
        this.params.createTimeEndMs = this.params.duration[1];
      } else {
        this.params.createTimeStartMs = '';
        this.params.createTimeEndMs = '';
      }
      if (this.params.auditTime) {
        this.params.auditStartTime = this.params.auditTime[0];
        this.params.auditEndTime = this.params.auditTime[1];
      } else {
        this.params.auditStartTime = '';
        this.params.auditEndTime = '';
      }
      this.params.statusCodeList = this.params.status ? [this.params.status] : [];

      supplier.SupplierStoreList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          // console.log(res.data);
          this.count = res.data.data.count;
          res.data.data.list.forEach((ele) => {
            const item = ele.storeInfo;

            item.createTimeStart = utils.exchangeTime(item.createTimeStart);
            item.flowStatus = this.flowStatusList[item.flowStatus];
            // item.status = this.statusList[item.status];
            item.createTime = utils.exchangeTime(item.createTime);
            item.auditPassTime = utils.exchangeTime(item.auditPassTime);
            // item.status = this.status[item.status - 1];
            // console.log(item.status, 'item.status');
            const types = item.enterpriseType.split(',');
            item.enterpriseType = [];
            types.forEach((val) => {
              item.enterpriseType.push(this.enterpriseTypeList[val * 1]);
            });
            // console.log(item.enterpriseType);

            if (item.enterpriseType[0]) {
              item.enterpriseType = item.enterpriseType.join(',');
            } else {
              item.enterpriseType = '';
            }
            // console.log(item);
            item.loading = false;
            item.disableReason = item.disableReason;
            this.tableData.push(item);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // handlePage(page, isSearch) {
    //   this.page = page;
    //   if (isSearch) {
    //     this.disablePage = true;
    //     // console.log(1234123);

    //     this.$nextTick(() => {
    //       this.disablePage = false;
    //       this.size = 10;
    //       this.getData();
    //     });
    //   } else {
    //     this.getData();
    //   }
    // },
    // handlePageSize(size) {
    //   this.size = size;
    //   this.page = 1;
    //   this.getData();
    // },
    addNew() {
      this.$router.push({ name: 'supplierStoreAdd' });
    },
    open() {
      // console.log(2);
    },
    cancel() {
      // console.log(3);
    },
    print() {
      // console.log(4);
    },
    deleteItem() {
      // console.log(5);
    },
    onDelete(id) {
      const params = { id };
      supplier.SupplierDelete(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('删除成功');
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.handleSearch(true);
    // console.log(this.$route);
    if (this.roleType !== 2) {
      this.columns.splice(1, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
  },

};
</script>

<style lang="less" scoped>
    // .form {
        // margin-top: 16px;
        // padding-bottom: 24px
    // }
    .bottomButton{
    margin-left: 220px;
    margin-top: 20px;
    >*{margin-right: 16px
  }
}

  .warnIcon {
  color: orange;
  font-size: 20px;
};

.stopReason {
  margin-top:8px; font-size: 12px;
}

.reason {
  margin-top:8px;
  font-size: 12px;
  margin-left: 24px;
}

.redMark {
  color: red;
  margin-top:6px;
  margin-left: 24px;
  font-size: 18px;
}

.stopInput{
  margin-left:24px;
  margin-right: 20px;
  width: 340px;
  margin-top: 0px;
}

</style>
